// extracted by mini-css-extract-plugin
export default {"layout":"HomeCardSkeleton_layout__UZzpn","notice":"HomeCardSkeleton_notice__SxG82","attendance":"HomeCardSkeleton_attendance__32ePZ"};